const isBigTipText = (tipText: string = "") => tipText.length > 140;

export { isBigTipText };
